module.exports = __webpack_public_path__ + "img/icon_password.3778b3f1.png";